import React from 'react';
import styles from '../styles/RewardDistributionStatus.module.css';
import { WeeklyRewardDistribution } from '../hooks/useHistoricLeaderboard';
import { appKitBlockchainService } from '../services/appkitBlockchain';

interface RewardDistributionStatusProps {
  rewardDistribution: WeeklyRewardDistribution | null;
  className?: string;
}

const RewardDistributionStatus: React.FC<RewardDistributionStatusProps> = ({ 
  rewardDistribution, 
  className = "" 
}) => {
  if (!rewardDistribution) {
    return (
      <div className={`${styles.rewardDistributionStatus} ${className}`}>
        <div className={styles.rewardsTitle}>
          Reward Distribution
        </div>
        <div className={styles.comingSoonMessage}>
          <p>💰 No reward distribution data available for this week</p>
          <span>Rewards may not have been calculated yet or no rewards were configured.</span>
        </div>
      </div>
    );
  }

  const distributionCategories = [
    {
      title: '🎮 Game Count Rankings:',
      rewards: [
        { key: 'gameCountBnb', label: 'BNB:', txHash: rewardDistribution.txHashes.gameCountBnb },
        { key: 'gameCountDxf', label: 'DXF:', txHash: rewardDistribution.txHashes.gameCountDxf }
      ]
    },
    {
      title: '💰 DXF Mining Rankings:',
      rewards: [
        { key: 'dxfMiningBnb', label: 'BNB:', txHash: rewardDistribution.txHashes.dxfMiningBnb },
        { key: 'dxfMiningDxf', label: 'DXF:', txHash: rewardDistribution.txHashes.dxfMiningDxf }
      ]
    }
  ];

  return (
    <div className={`${styles.rewardDistributionStatus} ${className}`}>
      <div className={styles.rewardsTitle}>
        Reward Distribution
      </div>
      <div className={styles.rewardsList}>
        {distributionCategories.map((category, categoryIndex) => (
          <div key={categoryIndex}>
            <div className={styles.categoryTitle}>
              {category.title}
            </div>
            {category.rewards.map(({ key, label, txHash }) => (
              <div key={key} className={styles.rewardItem}>
                <span className={styles.rewardLabel}>{label}</span>
                {txHash ? (
                  <a 
                    href={appKitBlockchainService.explorerTx(txHash)} 
                    target="_blank" 
                    rel="noreferrer" 
                    className={styles.txHashLink}
                  >
                    {txHash.slice(0, 6)}...{txHash.slice(-4)}
                  </a>
                ) : (
                  <span className={styles.pendingTx}>Pending</span>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RewardDistributionStatus;